module.exports = __webpack_public_path__ + "static/media/skull.996fb8b8.png";